import { Core } from "@/core/Core";

export default {

  /* Choices */

  async getChoices(context, {inventoryId, augment = 'backend'}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/choices`, {augment});
    } catch (e) {
      return null;
    }
  },

  async getChoice(context, {inventoryId, id}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/choices/${id}?augment=backend`);
    } catch (e) {
      return null;
    }
  },

  async createChoice(context, {inventoryId, data}) {
    try{
      return await Core.request("POST", "/api/inventory/" + inventoryId + "/choices", data);
    } catch (e) {
      return null;
    }
  },

  async saveChoice(context, {inventoryId, itemId, data}) {
    try{
      return await Core.request("PUT", "/api/inventory/" + inventoryId + "/choices/" + itemId, data);
    } catch (e) {
      return null;
    }
  },

  async deleteChoice(context, {inventoryId, itemId}) {
    try{
      return await Core.request("DELETE", "/api/inventory/" + inventoryId + "/choices/" + itemId);
    } catch (e) {
      return null;
    }
  },

  async saveChoicesPriorities(context, {inventoryId, data}) {
    try{
      return await Core.request("POST", "/api/inventory/" + inventoryId + "/choices/update-priority", data);
    } catch (e) {
      return null;
    }
  },


}